import { queryAll } from "../../../../../scripts/src/utils.js";
import { MaskedButton } from "../../../../../scripts/src/modules/mask-button.js";
class LogoGrid extends HTMLDivElement {
	maskBtns;
	constructor() {
		super();
		this.maskBtns = [...queryAll(".mask-btn")];

		this.maskBtns.forEach((el) => {
			if (!el.instance) el.instance = new MaskedButton(el);
		});
	}
}

customElements.define("logo-grid", LogoGrid, { extends: "div" });
